"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyIgea = void 0;
const helper_1 = require("../../helper");
class MyIgea {
    parse(pastedData, event, callbackEmit) {
        const regex = /\r\n/g;
        pastedData = pastedData.replace(regex, "\n");
        try {
            const patientInfoLines = (0, helper_1.substrInBetween)(pastedData, "Referral Source\n", "Sex: ");
            const patientInfoLinesArray = patientInfoLines.split("\n");
            const nameLine = patientInfoLinesArray[0];
            const nameObj = {
                firstName: (0, helper_1.trim)(nameLine.split(",")[1]),
                lastName: (0, helper_1.trim)(nameLine.split(",")[0]),
            };
            const phoneLine = patientInfoLinesArray[patientInfoLinesArray.length - 2];
            const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(phoneLine)
                .replace(/\s/, "")
                .replace(/[\s-()]/g, ""));
            const addressLines = (0, helper_1.substrInBetween)(pastedData, nameLine, phoneLine);
            const addressObj = { placeName: addressLines.replace("\n", " ") };
            const dobLine = patientInfoLinesArray[patientInfoLinesArray.length - 1];
            const dob = (0, helper_1.getDOB)((0, helper_1.trim)(dobLine));
            const primaryInsuranceRaw = (0, helper_1.substrInBetweenInclusive)(pastedData, "\nPayer Source Information\n", "\nPrimary Payer Source\n");
            const insuranceLines = (0, helper_1.substrInBetween)(primaryInsuranceRaw, "Policy # / HIC #:\n", "\nPrimary Payer Source\n");
            const insurance = insuranceLines.split("\n")[0];
            const caregiverRaw = (0, helper_1.substrInBetween)(pastedData, "Family Caregiver:", "Is able to asist:");
            const caregiverNameRaw = caregiverRaw.split("-")[0];
            const caregiverName = `${caregiverNameRaw.split(",")[1]} ${caregiverNameRaw.split(",")[0]}`;
            const caregiverPhoneNumberRaw = caregiverRaw.split("-")[1] + caregiverRaw.split("-")[2];
            const caregiverPhoneNumber = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(caregiverPhoneNumberRaw)
                .replace(/\s/, "")
                .replace(/[\s-()]/g, ""));
            const careGiver = [];
            if (caregiverName && caregiverPhoneNumber) {
                careGiver.push({
                    name: caregiverName,
                    phoneNo: caregiverPhoneNumber,
                    countryCode: "+1",
                    sortOrder: 1,
                });
            }
            let physicianRaw = (0, helper_1.substrInBetween)(pastedData, "Ordering Physician", "ass:");
            physicianRaw = (0, helper_1.substrInBetween)(physicianRaw, "Address:", "Medi");
            const physicianInfoArray = physicianRaw.split("\n");
            const physicianName = physicianInfoArray[0];
            const physicianNoLine = physicianInfoArray[physicianInfoArray.length - 1];
            const physicianNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(physicianNoLine
                .substring("Phone: ".length)
                .replace(/\s/, "")
                .replace(/[\s-()]/g, "")));
            const sendCallBackData = {
                patientInfo: Object.assign(Object.assign({}, nameObj), { address: addressObj, phoneNo, email: "", dob }),
                insurance,
                info: {
                    physician: [
                        {
                            name: physicianName,
                            phoneNo: physicianNo,
                            countryCode: "+1",
                            sortOrder: 1,
                        },
                    ],
                    pharmacy: [],
                    careGiver,
                },
            };
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error.message : error,
                errorStack: error.stack,
            });
        }
    }
    /**
     * @function getInsurance
     * @param insuranceInfo
     * @summary Getting Insurance from kinnserHospice
     */
    getInsurance(insuranceInfo) {
        return { insurance: (0, helper_1.trim)(insuranceInfo) };
    }
}
exports.MyIgea = MyIgea;
